// extracted by css-extract-rspack-plugin
export default {"ContextMenu":"ContextMenu-xys4yY","contextMenu":"ContextMenu-xys4yY"};